import React from "react";
import { graphql } from "gatsby";
import { StackedDisplay } from "./StackedDisplay";
import { formatSummaries } from "../../../lib/summaryDisplay";
import { getComponentSettings } from "../../../lib/componentSettings";
import {
  KontentComponentLayout,
  KontentComponentSettings,
  KontentSummary,
  StringValue,
} from "../../../types";

interface Props extends KontentComponentLayout, KontentComponentSettings {
  heading: StringValue;
  summaries: {
    modular_content: KontentSummary[];
  };
}

const StackedDisplayContainer: React.FC<Props> = ({
  summaries,
  heading,
  ...props
}) => {
  if (!summaries?.modular_content) return null;

  const summaryDisplay = formatSummaries(summaries.modular_content);
  const settings = getComponentSettings({ ...props });

  if (!summaryDisplay) return null;

  return (
    <StackedDisplay
      summaries={summaryDisplay}
      heading={heading.value}
      {...settings}
    ></StackedDisplay>
  );
};

export default StackedDisplayContainer;

export const fragmentStackedDisplayContainer = graphql`
  fragment StackedDisplay on kontent_item_stacked_display {
    elements {
      heading {
        value
      }
      summaries {
        modular_content {
          ...kontentSummary
        }
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      component_settings__anchor_name {
        value
      }
      component_layout__component_width {
        value {
          codename
        }
      }
    }
  }
`;
